import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/900.css";
import "./utils/globalStyles.css";
import { createTheme } from "@mui/material";
import { getButtonOverrides } from "./ui/overrides/button";

const colors = {
  champagne: "#DFCAB9",
  champagneDisable: "#86796F",
  champagneDark: "#2D2825",
  olive: "#8DAA91",
  oliveDark: "#618666",
  lavander: "#DBCBD8",
  lavanderDark: "#542344",
  black: "#000000",
  white: "#FFFFFF",
} as const;

export type Colors = typeof colors;

const {
  champagne,
  champagneDisable,
  olive,
  oliveDark,
  lavander,
  lavanderDark,
  champagneDark,
  white,
} = colors;

export default createTheme({
  palette: {
    primary: {
      main: olive,
      dark: oliveDark,
    },
    secondary: {
      main: lavander,
      dark: lavanderDark,
    },
    background: {
      default: white,
      paper: champagne,
    },
    error: {
      main: "#fb1a1a",
      light: "#ff9696",
      dark: "#b10b0b",
    },
    text: {
      primary: champagneDark,
      secondary: champagne,
      disabled: champagneDisable,
    },
    other: {
      white,
    },
    grey: {
      100: "#F5F5F5",
      300: "#828282",
      500: champagneDisable,
      700: "#4F4F4F",
      800: champagneDark,
    },
  },
  typography: {
    fontSize: 18,
    htmlFontSize: 18,
    fontFamily: [
      '"Inter"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h1: {
      fontWeight: 900,
      fontSize: 54,
      lineHeight: "64px",
    },
    h2: {
      fontWeight: 900,
      fontSize: 40,
      lineHeight: "52px",
      color: "text",
    },
    h3: {
      fontWeight: 900,
      fontSize: 28,
      lineHeight: "34px",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "text.primary",
        variant: "body1",
      },
    },
    MuiButton: getButtonOverrides(colors),
  },
});
